import useHomeSendExtra from './useHomeSendExtra';
import useTypedSelector from '../../../common/hook/useTypedSelector';
import {useFetchInfo} from '../../../common/util/fetch';
import {getTimeTableSortingOption} from '../../timeTable/function';
import {ActionType as TimeTableActionType} from '../../timeTable/state/action';
import {ITimeTableDay} from '../../timeTable/type';
import {HomeTabPage} from '../type';

export default function useHomeMainExtra() {
  const [tabPage, secondTab] = useTypedSelector(({home}) => [
    home.tabPage,
    home.secondTabs[home.tabPage].selected,
  ]);

  const isTimeTable = tabPage === TIME_TABLE;
  const isNewTab = secondTab === 'new';
  const isCompleteTab = secondTab === 'complete';
  const isDaysTab = isTimeTable && !isNewTab && !isCompleteTab;
  const timeTableFetch = useFetchInfo(
    isNewTab
      ? TimeTableActionType.FetchNewContents
      : isCompleteTab
        ? TimeTableActionType.FetchCompletedContents
        : TimeTableActionType.FetchWeekday,
    isDaysTab ? secondTab : TIME_TABLE
  );

  const [hotListCount, timeTableListCount, timeTableSortKey] = useTypedSelector(
    state => {
      const {main, timeTable} = state;
      const {newTabContents, completeTab, daysTab} = timeTable[TIME_TABLE];
      const dayTab = isDaysTab
        ? daysTab[secondTab as ITimeTableDay]
        : undefined;

      return [
        /**
         * 지금 핫한 탭은 화면 넓이(isSmall)에 따라 contents가 최대 6개 or 최대 8개로 보여서
         * 화면에 따라 다르게 개수를 다르게 보내줘야하지만, 자주 확인하지 않는 로그이기 때문에 slice 8개 기준 그대로 보여준다.
         * (기획 협의 완료. Ethel)
         */
        main.hotList.reduce(
          (prev, {bigContent, contents = []}) =>
            prev + (bigContent ? 1 : 0) + contents.length,
          0
        ),
        isTimeTable
          ? isNewTab
            ? newTabContents.length
            : isCompleteTab
              ? (completeTab.bigContent ? 1 : 0) + completeTab.contents.length
              : (dayTab?.bigContent ? 1 : 0) + (dayTab?.contents.length || 0)
          : 0,
        timeTable.sortKeyByDayTab,
      ];
    }
  );

  useHomeSendExtra({
    canSendExtra: tabPage === HomeTabPage.Main && secondTab === 'hot',
    listCount: hotListCount,
  });

  useHomeSendExtra({
    canSendExtra: isTimeTable && timeTableFetch.fetchStatus === 'success',
    listCount: timeTableListCount,
    customProps: {
      sorting_option: getTimeTableSortingOption(timeTableSortKey),
      list_type: 'triple',
    },
  });
}

const TIME_TABLE = HomeTabPage.TimeTable;
